export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU'